import { InputLabel, styled } from "@mui/material";
import { CONSTANTS } from "../../CONSTANTS";

const StyledInputLabel = styled(InputLabel)({
    "&.MuiInputLabel-root.MuiInputLabel-shrink": {
        color: CONSTANTS.COLORS.LABEL_GREY,
        fontSize: "12px",
        fontWeight: 400,
        fontFamily: "Arial",
    },
})

export default StyledInputLabel;